import React from 'react';
import { brand, footerProducts, topNav } from '../data/siteData';
import { GearIcon, LocationIcon, WhatsAppIcon } from './Icons';
import AppLink from './AppLink';
import Reveal from './Reveal';

export default function Layout({ pathname, onNavigate, children }) {
  const atHome = pathname === '/';

  return (
    <div className="app-shell">
      <header className="site-header">
        <div className="header-inner container">
          <div className="brand-wrap">
            <AppLink href="/" onNavigate={onNavigate} className="brand-link" active={atHome}>
              <img src={brand.logoImage} alt="Logo" className="brand-logo" />
              <span className="brand-name">{brand.appName}</span>
            </AppLink>

            <nav className="header-nav">
              {topNav.map((item) => (
                <AppLink
                  key={item.label}
                  href={item.href}
                  onNavigate={onNavigate}
                  className="header-nav-link"
                  active={item.href === pathname}
                >
                  {item.label}
                </AppLink>
              ))}
            </nav>
          </div>

          <div className="header-actions">
            <AppLink href="/downloads" onNavigate={onNavigate} className="header-download-link" active={pathname === '/downloads'}>
              Downloads
            </AppLink>

            <button
              type="button"
              className="icon-button"
              title="Configurações"
              aria-label="Configurações"
            >
              <GearIcon className="icon" />
            </button>
          </div>
        </div>
      </header>

      <main>{children}</main>

      <footer className="site-footer">
        <div className="footer-pattern" />
        <div className="container footer-inner">
          <div className="footer-grid">
            <Reveal className="footer-about" variant="fade-up" duration={650} threshold={0.12}>
              <div className="footer-brand">
                <img src={brand.logoImage} alt="Logo" className="footer-logo" />
                <span>{brand.companyName}</span>
              </div>
              <p>
                Desenvolvemos soluções tecnológicas inovadoras para otimizar processos empresariais e impulsionar o crescimento
                dos nossos clientes.
              </p>
              <div className="footer-meta">
                <a href={brand.whatsappUrl} target="_blank" rel="noreferrer" className="footer-contact">
                  <WhatsAppIcon className="icon icon--small" />
                  WhatsApp
                </a>
                <p className="footer-location">
                  <LocationIcon className="icon icon--tiny" />
                  Blumenau, SC - Brasil
                </p>
              </div>
            </Reveal>

            <Reveal className="footer-links" variant="fade-up" duration={650} delay={90} threshold={0.12}>
              <h3>Produtos</h3>
              <ul>
                {footerProducts.map((product) => (
                  <li key={product.label}>
                    <AppLink
                      href={product.href}
                      onNavigate={onNavigate}
                      className="footer-link"
                      active={product.href === pathname}
                    >
                      {product.label}
                    </AppLink>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          <Reveal className="footer-bottom" variant="fade-up" duration={650} delay={160} threshold={0.1}>
            <p>© 2024 Arco Tech Sistemas. Todos os direitos reservados.</p>
            <div aria-hidden="true" />
          </Reveal>
        </div>
      </footer>
    </div>
  );
}
